import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SponsorshipInterface } from '../../../shared/models/sponsorship.interface';
import { CustomerInterface } from '../../../account/models/customer.interface';
import { CustomerStorageService } from '../../../account/services/customer-storage.service';

@Component({
  selector: 'app-sponsorship-list',
  templateUrl: './sponsorship-list.component.html',
  styleUrls: ['./sponsorship-list.component.css'],
  standalone: false
})
export class SponsorshipListComponent implements OnInit {

  brand?: string;
  listTab: string;
  faqPageCode: string;
  managementTab: string;
  supportUser: SupportUserInterface;
  selectedSponsorship: SponsorshipInterface|null;
  customer: CustomerInterface|null;

  constructor(
    private location: Location,
    private sanitizer: DomSanitizer,
    private customerStorageService: CustomerStorageService
  ) {}

  ngOnInit() {
    this.listTab = '';
    this.managementTab = '';
    this.faqPageCode = 'sponsorship';
    this.brand = environment.data.brand;
    this.customer = this.customerStorageService.getCustomer();
    this.selectedSponsorship = this.customer.sponsorshipCode ? this.customer.sponsorshipCode : null;
    this.setActiveTab('liste');
  }

  sanitizeContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml('<i>Je te recommande les forfaits Prixtel : sans engagement, ' +
    'ils s\'adaptent chaque mois à ta ' +
    'consommation ! Profite d’un mois de forfait GRATUIT en cliquant sur mon lien de parrainage : ' +
    'https://www.prixtel.com?sponsorshipCode=' + this.selectedSponsorship.code + '</i>');
  }

  setActiveTab(tab: string) {
    this.managementTab = '';
    this.listTab = '';

    if (['', 'undefined', undefined].indexOf(tab) !== -1) {
      tab = 'liste';
    }

    switch (tab) {
      case 'liste':
        this.listTab = 'active';
        break;
      case 'gestion':
        this.managementTab = 'active';
        break;
    }

    this.location.replaceState('/parrainage/' + tab);
  }

  copyLinkContent(event) {
    const sticker = document.getElementById('sticker');
  
    sticker.style.display = 'block';
    navigator.clipboard.writeText(
      'Je te recommande les forfaits Prixtel : sans engagement, ' +
      'ils s\'adaptent chaque mois à ta ' +
      'consommation ! Profite d’un mois de forfait GRATUIT en cliquant sur mon lien de parrainage : ' +
      'https://www.prixtel.com?sponsorshipCode=' + this.selectedSponsorship.code
    );
    sticker.textContent = 'Le message a été copié.';
    setTimeout( () => {
      sticker.style.display = 'none';
    }, 3000);
  }
}
